import { render, staticRenderFns } from "./BtnInner.vue?vue&type=template&id=35d26b83&"
import script from "./BtnInner.vue?vue&type=script&lang=js&"
export * from "./BtnInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports